import styled from "@emotion/styled";
import { theme } from "@styles/theme";
const { sm, md, lg, xl } = theme.breakpoints;

export const ContainerSearch = styled.div`
  @media (max-width: ${lg}) {
    display: none;
  }
`;
